import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-up",
  "use": "chevron-up-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"chevron-up\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.646 5.146a.5.5 0 0 1 .708 0l5 5a.5.5 0 0 1-.708.708L8 6.207l-4.646 4.647a.5.5 0 0 1-.708-.708l5-5Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol